import React from 'react';
import cx from 'classnames';
import ListProps from './List.types';
import styles from './List.module.scss';
import Text from '../Text';
import Icon from '../Icon';
import { ConditionBlock, ElementBlock, StringBlock } from '../../utils/Block';

const List = ({
  children,
  color,
  layout = 'auto',
  wrap = 'no-wrap',
  className = '',
  iconHeadingTextOptions,
  iconsFill = '#ccc',
  halfContainer = false,
  type = 'complex',
  dataCy = 'list',
}: ListProps) => {
  return (
    <ul
      data-cy={dataCy}
      className={cx(`${styles[layout]} ${styles[wrap]} ${className}`, styles[color], {
        [styles.list]: !iconHeadingTextOptions?.length,
        [styles.noPadding]: iconHeadingTextOptions?.length,
        [styles.halfContainer]: halfContainer,
        [styles.basic]: type === 'basic',
      })}>
      {children}
      {iconHeadingTextOptions?.map((node, index) => {
        const elementId = `id_${node?.text || index}`;
        return (
          <li key={elementId}>
            {type === 'basic' ? (
              node.text
            ) : (
              <div className={styles.iconHeadingTextWrapper}>
                {node.icon && (
                  <div className={styles.square}>
                    <div className={styles.iconWrapper}>
                      <Icon
                        height='100'
                        width='100'
                        viewBox='0 0 100 100'
                        fill={iconsFill}
                        title={node.icon?.title}
                        {...node.icon}
                      />
                    </div>
                  </div>
                )}
                {node.svg && <div className={styles.square}><div className={styles.svgWrapper}>{node.svg}</div></div>}
                <div className={styles.textWrapper}>
                  {node.heading && (
                    <Text bold className={cx(styles.title, styles[color])}>
                      {node.heading}
                    </Text>
                  )}
                  {node.text && (
                    <ConditionBlock>
                      <StringBlock value={node.text}>
                        <Text className={cx(styles.detail, styles[color])}>{node.text}</Text>
                      </StringBlock>
                      <ElementBlock value={node.text}>{node.text}</ElementBlock>
                    </ConditionBlock>
                  )}
                </div>
              </div>
            )}
          </li>
        );
      })}
    </ul>
  );
};

export default List;
